{
  "title": "PM",
  "actions": {
    "new": "Skapa PM",
    "newAndClear": "Skapa och rensa",
    "reorderItem": "Dra för att flytta {{headline}}",
    "selectAll": "Markera alla",
    "deselectAll": "Avmarkera alla",
    "removeBlock": "Ta bort block",
    "removeItem": "Ta bort {{headline}}",
    "addBlock": "Lägg till {{label}}",
    "insertDocument": "Infoga \"{{title}}\"",
    "removeInsertedDocument": "Ta bort infogat {{title}}",
    "removeInsertedLine": "Ta bort raden {{text}}"
  },
  "labels": {
    "memo": "PM:et",
    "selection": "Urval",
    "planningTitle": "Rubrik på planeringen",
    "assignmentTitle": "Rubrik på uppdraget",
    "memoTitle": "Rubrik på PM:et",
    "planningSlugline": "Slugg på planeringen",
    "assignmentSlugline": "Slugg på uppdraget",
    "dateFrom": "Från datum",
    "dateTo": "Till datum",
    "candidates": "Att välja mellan",
    "print": "Printartiklar",
    "planning": "Planeringar",
    "article": "Artiklar",
    "events": "Händelser",
    "insertable": "Infoga publicerat PM",
    "chooseBlock": "Välj block",
    "insertSelectedInto": "Lägg markerade i block",
    "unassignedCount": "{{count}} markerade",
    "preview": "Förhandsgranska",
    "keywordFor": "Nyckelord för {{headline}}",
    "noKeyword": "-"
  },
  "placeholders": {
    "template": "Välj mall",
    "section": "Välj sektion",
    "memoSection": "Sektion för PM",
    "editorialInfoType": "Välj redaktionell info-typ",
    "newsvalue": "Nyhetsvärde",
    "filterSection": "Sektion",
    "filterStory": "Story",
    "variant": "Välj dagar"
  },
  "errors": {
    "itemsRequired": "Välj poster för att skapa PM:et",
    "sectionMissing": "Sektionen {{section}} hittades inte",
    "sectionRequired": "Välj vilken sektion PM:et gäller",
    "templateRequired": "Välj en mall för att söka innehåll"
  },
  "hints": {
    "draftOnly": "PM:et skapas som ett utkast. Det publiceras aldrig direkt."
  },
  "banner": {
    "offline": "Du är offline. PM kan inte skapas förrän anslutningen är tillbaka."
  },
  "toasts": {
    "created": "PM skapat"
  },
  "prompts": {
    "createSeveral": "Du kommer att skapa följande PM"
  }
}
